import { useQuery } from '@tanstack/react-query';
import type { ChangeLogEntry, Building } from './types';
import { MOCK_BUILDING, MOCK_CHANGE_LOG } from './mocks';

// ─── Data fetching hooks ─────────────────────────────────────────────────────

export const QUERY_KEYS = {
  building: (buildingId: string) => ['urban-map', 'building', buildingId] as const,
  changeLog: (buildingId: string) => ['urban-map', 'building', buildingId, 'change-log'] as const,
};

export function useBuilding(buildingId: string) {
  return useQuery<Building>({
    queryKey: QUERY_KEYS.building(buildingId),
    queryFn: async () => {
      const res = await fetch(`/api/urban-map/buildings/${buildingId}`);
      if (!res.ok) {
        throw new Error('Impossible de récupérer les informations du bâtiment.');
      }
      return res.json() as Promise<Building>;
    },
    initialData: MOCK_BUILDING,
  });
}

export function useChangeLog(buildingId: string) {
  return useQuery<ChangeLogEntry[]>({
    queryKey: QUERY_KEYS.changeLog(buildingId),
    queryFn: async () => {
      const res = await fetch(`/api/urban-map/buildings/${buildingId}/change-log`);
      if (!res.ok) {
        throw new Error('Impossible de récupérer le journal des modifications.');
      }
      return res.json() as Promise<ChangeLogEntry[]>;
    },
    initialData: MOCK_CHANGE_LOG,
  });
}


